export default __webpack_public_path__ + "static/media/14.6dbb6fbc.png";